export const BEST_BROADWAY_COLUMNS = 3
export const CHEAP_TICKETS_COLUMNS = 4
